// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"266":"541dfd30","898":"a7014d9f"}[chunkId] + ".chunk.css";
};